<template>
    <div class="Contact">
        <div class="pageContent">
            <TopLogoBar logoColor="black" textColor="#000" title="Contattaci" />
            <div class="container infoContainer">
                <div class="columns">
                    <div class="column is-6 is-offset-3">
                        <b-message title="Success" type="is-success" aria-close-label="Chiudi messaggio">
                            Messaggio invia
                        </b-message>
                        <b-field grouped>
                            <b-field label="Nome" label-position="on-border" expanded>
                                <b-input v-model="form.name" required autocomplete="first-name"></b-input>
                            </b-field>
                            <b-field label="Cognome" label-position="on-border" expanded>
                                <b-input v-model="form.surname" required autocomplete="last-name"></b-input>
                            </b-field>
                        </b-field>
                        <b-field>
                            <b-field label="Ragione Sociale" label-position="on-border" expanded>
                                <b-input v-model="form.rag_soc" autocomplete="organization"></b-input>
                            </b-field>
                        </b-field>
                        <b-field grouped>
                            <b-field label="Numero di telefono" label-position="on-border" expanded>
                                <b-input v-model="form.telephone" name="phone" type="tel" autocomplete="tel"></b-input>
                            </b-field>
                            <b-field label="Email" label-position="on-border" expanded>
                                <b-input v-model="form.email" type="email" required autocomplete="email"></b-input>
                            </b-field>
                        </b-field>
                        <b-field label="Ulteriori richieste" label-position="on-border">
                            <b-input v-model="form.extrainfo" maxlength="250" type="textarea"></b-input>
                        </b-field>
                        <b-button icon-left="arrow-up-bold-circle-outline" type="is-danger" style="width: 100%"
                            @click="sendMessage">Invia</b-button>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Footer from "@/components/Footer";
    import TopLogoBar from "@/components/TopLogoBar";
    export default {
        name: "Contact",
        props: [],
        components: {
            TopLogoBar,
            Footer,
        },
        data() {
            return {
                form: {
                    name: "",
                    surname: "",
                    rag_soc: "",
                    telephone: "",
                    email: "",
                    extrainfo: "",
                },
            };
        },
        methods: {
            sendMessage() {
                console.log("sadsa");
            },
        },
    };
</script>

<style scoped lang="scss">
    .Contact {
        width: 100%;

        .pageContent {
            width: 100%;
            position: relative;
            color: #000;

            .infoContainer {
                // display: flex;
                // height: 100%;
                padding: 20px;

                @media only screen and (min-width: 768px) {
                    margin-top: 100px;
                }
            }
        }
    }
</style>

<style lang="scss">
    .Contact {
        width: 100%;

        .label {
            font-weight: 400 !important;
        }
    }
</style>